import React from "react";
import { useSelector, useDispatch } from "react-redux";

import ConversationCard from "./ConversationCard";
import useNovaAiResponseApi from "./hooks/useNovaAiResponseApi";
import useApplicationTracker from "customHooks/useApplicationTracker";
import "./NovaHistory.scss";
import {
  setRegenerateAiResponse,
  setChangedConversation,
} from "store/AiFeatures/GoalsCreateWithNovaAI/action";

const ConversationCards = (props) => {
  const {
    setShowHistory,
    setNewConversationId,
    page,
    setPage,
    setisConversationChanged,
    setChatPage,
    setSentMessageText,
  } = props;
  const dispatch = useDispatch();
  const { captureUserEvent } = useApplicationTracker();
  const { accountId } = useSelector((state) => state.user);
  const { propsForGoalsNovaAi } = useNovaAiResponseApi();
  const {
    fetchAllConversations,
    fetchConversationMessages,
    getUpdatedConversation,
  } = propsForGoalsNovaAi;
  const novaConversations = useSelector(
    (state) => state?.aiFeatures?.goalsCreateWithNovaAI?.allConversations || []
  );
  const currentPage = useSelector(
    (state) =>
      state?.aiFeatures?.goalsCreateWithNovaAI?.allConversationsCurrentPage
  );
  const totalPages = useSelector(
    (state) =>
      state?.aiFeatures?.goalsCreateWithNovaAI?.allConversationsTotalPages
  );
  const handleSelectConversation = async (
    conversationId,
    conversationTitle
  ) => {
    setNewConversationId(conversationId);
    setPage(1);
    await getUpdatedConversation(conversationId);
    dispatch(setRegenerateAiResponse(conversationId, false));
    dispatch(setChangedConversation(true, conversationId, conversationTitle));
    await fetchConversationMessages({ conversationId });
    setisConversationChanged(true);
    setSentMessageText("");
    setShowHistory(false);
    setChatPage(1);
    captureUserEvent("nova_prev_conversation_card_clicked", {
      accountId: accountId,
    });
  };

  const handleShowMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchAllConversations({ page: nextPage });
  };

  if (!novaConversations || novaConversations.length === 0) {
    return (
      <div className="skeleton-container">
        {[...Array(9)].map((_, index) => (
          <div key={index} className="conversation-loading-skeleton-card" />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="h-100 mx-16 mt-16 overflow-y-auto nova-history-conversation-cards">
        {novaConversations.map((conv) => (
          <ConversationCard
            key={conv.id}
            id={conv.id}
            name={conv.name}
            created_at={conv.created_at}
            onClickConversationCard={() =>
              handleSelectConversation(conv.id, conv.name)
            }
          />
        ))}
      </div>
      <div className="px-15 py-20 nova-history-footer">
        {currentPage < totalPages && (
          <div
            className="cursor-pointer show-more-conversations"
            onClick={handleShowMore}
          >
            Show More
          </div>
        )}
      </div>
    </>
  );
};

export default ConversationCards;
